import Vue from 'vue';
import _ from 'underscore';
import Utils from '../utils';
import './activity_editor/components';

export default class ActivityEditor {
  get eventSource() {
    if (!this._eventsource) {
      this._eventsource = $({});
    }
    return this._eventsource;
  }

  set item(item) {
    this.vue.changeItem(item);
  }

  get item() {
    return this.vue.getItem();
  }

  constructor(container, data, options) {
    this.container = container;
    this.options = Utils.extend(
      {
        upload: {},
        singleFocus: true,
        locked: false,
        comment: false,
        highlight: false,
        isRecording: false,
        buttonText: i18n.__('app_save'),
        completeSaveButtonText: i18n.__('app_save_complete'),
        changeButtonText: i18n.__('app_edit'),
        publishPostButtonText: i18n.__('app_publish_post'),
        isTeacher: !!window.editor,
      },
      options,
    );

    data = Utils.extend(
      {
        provideSave: true,
        providePublish: false,
        header: {},
      },
      data,
    );

    this.data = data;
    this.data.options = this.options;

    this.trackedData = {
      body: this.data.item.body,
      attachments: this.data.item.attachments.slice(),
    };

    this.autoSaveTimer;
    this.useAutoSave = options.autoSave && options.autoSave.autoSaveBehaviors.includes(data.type);
    this.build();
  }

  resetItem() {
    this.vue.reset();
  }

  getData() {
    return this.data;
  }

  destroy() {
    this.vue.$el.remove();
    this.vue = null;
  }

  focus() {
    if (this.vue) {
      this.vue.focus();
    }
  }

  blur() {
    if (this.vue) {
      this.vue.blur();
    }
  }

  disable() {
    this.vue.disable();
  }

  enable() {
    this.vue.enable();
  }

  updateAttachments(attachments) {
    this.vue.updateAttachments(attachments);
  }

  resetStatus(force = false) {
    const buttonPanel = $('.activity-editor__button-panel');
    if (force || !buttonPanel.hasClass('error')) {
      buttonPanel.removeClass('error');
      $('.activity-editor__status').text('');
    }
  }

  build() {
    var that = this;
    this.vue = new Vue({
      el: this.container,
      template: `
      <component v-bind:is="!this.options.isDefaultEditor && type === 'logbook' ? 'li' : 'div'" class="lp--activityEditorContainer" v-bind:class="{ 'draft': item.isDraft, 'hide': hideEditor(), 'locked': isLocked }" :data-uuid="item.uuid">
        <activity-editor ref="editor" :isDefaultEditor="this.options.isDefaultEditor" :isTeacher="this.options.isTeacher" :item="item" :user="user" :key="item._bust" :options="options" :type="type" :header="header" @recorderStateChanged="recorderStateChanged" @stateChanged="stateChanged" @updateContent="updateContent" @dirtyStateChange="dirtyStateChanged" @comment="dispatchComment"></activity-editor>
        <div class="button-wrapper activity-editor__button-panel">
          <span class="activity-editor__status"></span>
          <button type="submit" v-if="(provideSave || useAutoSave()) && !options.locked" v-bind:class="['secondary-button', 'activity-editor__save-button', { 'auto-save': useAutoSave() }]" v-on:click="save">
            {{options.buttonText}}
          </button>
          <button type="submit" v-if="providePublish && !options.locked" v-bind:disabled="!item.isDraft" v-bind:class="['primary-button', 'lp--activityEditorPublish']" v-on:click="publishPost">
            {{options.publishPostButtonText}}
          </button>
          <button type="submit" v-if="shouldShowChangeButton() && availableStates.indexOf('active') >= 0" class="secondary-button" v-on:click="continueWorking">
            {{options.changeButtonText}}
          </button>
          <button type="submit" v-if="provideSave && !options.locked && availableStates.indexOf('done') >= 0" class="lp--activityEditorSubmit" v-on:click="completeAndSave">
            {{options.completeSaveButtonText}}
          </button>
        </div>
      </component>`,
      mounted: function () {
        this._cnt = this.item.body;
      },
      computed: {
        availableStates: function () {
          return Utils.getAvailableBehaviorStates(this.item.state, false).map((state) => {
            return state.event;
          });
        },
        isLocked: function () {
          return this.$data.options.locked || ['done', 'accepted'].includes(this.item.state);
        },
      },
      methods: {
        recorderStateChanged: function (recorderIsDisplayed) {
          this.$set(this.$data.options, 'isRecording', !!recorderIsDisplayed);
        },
        stateChanged: function (value, composite = false) {
          if (!composite) {
            this.$emit('stateChanged', this.getItem());
          }
        },
        blur: function () {
          if (this.$refs.editor) {
            this.$refs.editor.blur();
          }
        },
        focus: function () {
          if (this.$refs.editor) {
            this.$refs.editor.focus();
          }
        },
        disable: function () {
          this.$refs.editor.disable();
        },
        enable: function () {
          this.$refs.editor.enable();
        },
        save: function (isDraft) {
          this.item.isDraft = isDraft;
          this.$emit('save', this.getItem());
        },
        completeAndSave: function () {
          this.item.state = 'done';
          this.item.isDraft = false;
          this.stateChanged('done', true);
          this.save(false);
          clearTimeout(that.autoSaveTimer);
        },
        publishPost: function () {
          if (this.item.isDraft || this.isDirty) {
            this.save(false);
            setTimeout(() => {
              this.$emit('resetStatus');
            }, 5000);
          }
        },
        continueWorking: function () {
          this.item.state = 'active';
          this.item.isDraft = true;
          this.stateChanged('active');
          this.enable();
          this.focus();
        },
        changeItem: function (item) {
          this._cnt = '';
          this.$set(this.$data, 'item', item);
        },
        reset: function () {
          this.$set(this.$data, 'item', {
            body: ' ',
            attachments: [],
            _bust: Math.random(),
            state: this.item.state,
            isDraft: false,
          });
        },
        updateContent: function (cnt) {
          this._cnt = cnt;
          this.$emit('updateContent');
        },
        dirtyStateChanged: function () {
          this.isDirty =
            this._cnt !== that.trackedData.body || !_.isEqual(that.trackedData.attachments, this.item.attachments);
          this.item.isDraft = this.isDirty;
          if (this.isDirty && this.item.state === 'done') {
            this.item.state = 'active';
          }
          this.$emit('dirtyStateChanged', this.getItem());
        },
        getItem: function () {
          this.item.body = this._cnt;
          let data = Utils.extend({}, this.item);
          data.attachments = data.attachments.filter((attachment) => {
            return attachment.id === undefined;
          });
          return data;
        },
        dispatchComment: function () {
          that.eventSource.trigger('comment', this.getItem());
        },
        useAutoSave: () => {
          return this.useAutoSave;
        },
        shouldShowChangeButton: () => {
          return (
            !this.options.locked &&
            !['written_quiz', 'logbook'].includes(this.data.type) &&
            (this.data.item.state === 'done' || this.data.item.state === 'accepted')
          );
        },
        updateAttachments: (attachments) => {
          this.item.attachments.forEach((attachment) => {
            attachment.id = attachments.find((att) => {
              return att.url === attachment.url;
            }).id;
          });
        },
        hideEditor: () => {
          return (
            this.data.type === 'logbook' && (this.data.item.state === 'done' || this.data.item.state === 'accepted')
          );
        },
      },
      data: function () {
        return that.getData();
      },
    });

    this.vue.$on('resetStatus', () => {
      this.resetStatus(true);
    });

    this.vue.$on('dirtyStateChanged', (item) => {
      this.resetStatus(true);
      if (!['done', 'accepted'].includes(this.data.item.state)) {
        if (this.useAutoSave) {
          clearTimeout(this.autoSaveTimer);
          clearTimeout(this.clearStatusTimer);
          this.autoSaveTimer = setTimeout(() => {
            this.vue.save(true);
          }, this.options.autoSave.autoSaveInterval || 1000);
          this.clearStatusTimer = setTimeout(() => {
            this.resetStatus();
          }, 5000);
        }
        this.eventSource.trigger('dirtyStateChanged', item);
      }
    });

    this.vue.$on('updateContent', () => {
      this.eventSource.trigger('updateContent');
    });

    this.vue.$on('save', (item) => {
      this.eventSource.trigger('save', item);
    });

    this.vue.$on('stateChanged', (item) => {
      this.eventSource.trigger('stateChanged', item);
    });
  }
}

ActivityEditor.AttachmentSource = {
  Upload: 'upload',
  Drive: 'drive',
  Dropbox: 'dropbox',
  Webcam: 'webcam',
  Microphone: 'microphone',
  OneDrive: 'onedrive',
  DropPaste: 'drop_paste',
};
